module.exports = __webpack_public_path__ + "static/bannerImg-fe69e69fe4770f9e798d9d4b74fba967.png";